import React from "react";
import { Modal, Form, Input, Select, Space } from "antd";

export const VendorFilter = ({
  form,
  isModalOpen,
  handleCancel,
  setFilterForm,
  filterForm,
  handleFilter,
}) => {
  return (
    <Modal
      title="Filters"
      open={isModalOpen}
      onOk={handleFilter}
      okText="Filter Data"
      onCancel={handleCancel}
    >
      <Form form={form} layout="vertical">
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "20px",
          }}
        >
          <Form.Item name="name" className="subscription-plan">
            <Input
              value={filterForm?.name}
              onChange={(e) =>
                setFilterForm({ ...filterForm, name: e.target.value })
              }
              size="large"
              placeholder="Filter by Name"
            />
          </Form.Item>
          <Form.Item name="mobile" className="subscription-plan">
            <Input
              value={filterForm?.mobile}
              onChange={(e) =>
                setFilterForm({ ...filterForm, mobile: e.target.value })
              }
              size="large"
              placeholder="Filter by Mobile"
            />
          </Form.Item>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "20px",
          }}
        >
          <Form.Item name="isActive" className="subscription-plan">
            <Select
              value={filterForm?.isActive}
              onChange={(value) =>
                setFilterForm({ ...filterForm, isActive: value })
              }
              placeholder="Filter by Status"
              style={{ width: "100%" }}
              options={[
                { value: "false", label: "Inactive" },
                { value: "true", label: "Active" },
              ]}
            />
          </Form.Item>
        </div>
      </Form>
    </Modal>
  );
};
